import { useUserQuery } from '@/hooks/react-query/user/use-user'
import { cn, getLastSegment } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useMemo } from 'react'
import { menuMobileConfig } from '../nav-config'

export const MobileNavFooter = () => {
  const { data } = useUserQuery()
  const t = useTranslations('header')

  const isLogin = !!data

  const menu = useMemo(
    () =>
      menuMobileConfig.footer.menu.filter(
        (item) => !(item.href === '/login' && isLogin)
      ),
    [isLogin]
  )

  return (
    <ul>
      {menu.map((item) => (
        <li key={item.href}>
          <Link
            href={item.href}
            className={cn(
              'flex items-center gap-0.5 py-2.5 font-sans text-sm font-normal text-neutral-500',
              item.className
            )}
            ga-tracking-value={`menu__footer__${getLastSegment(item.title)}`}
            ga-tracking-label={t(item.title)}
          >
            {t(item.title)} {item.icon && <item.icon size={16} />}
          </Link>
        </li>
      ))}
    </ul>
  )
}
